module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_pp3_8.e35aff32.png";